'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function PortfolioCTA() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -5% 0px' }
    );

    const elements = document.querySelectorAll('.animate-on-scroll');
    elements?.forEach((el) => observer?.observe(el));

    return () => observer?.disconnect();
  }, []);

  return (
    <section className="py-20 lg:py-32 relative z-10 bg-gray-950">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-gray-900 to-gray-800 border border-zinc-700 p-12 md:p-20 animate-on-scroll animate-in">
          <div className="absolute inset-0 opacity-10">
            <div
              className="absolute inset-0"
              style={{
                backgroundImage:
                  'linear-gradient(to right, #3F3F46 1px, transparent 1px), linear-gradient(to bottom, #3F3F46 1px, transparent 1px)',
                backgroundSize: '80px 80px',
              }}
            ></div>
          </div>

          <div className="relative z-10 text-center">
            <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
              Want to Be Our Next Success Story?
            </h2>
            <p className="text-gray-400 text-lg md:text-xl max-w-3xl mx-auto mb-12 leading-relaxed">
              Let's discuss how we can help you achieve similar results. Schedule a consultation with our team.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                href="/contact"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-blue-500 text-white rounded-lg font-semibold hover:bg-blue-600 transition-colors duration-200"
              >
                <span>Start Your Project</span>
                <Icon name="ArrowRightIcon" size={20} />
              </Link>
              <Link
                href="/services"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-transparent border-2 border-zinc-700 text-white rounded-lg font-semibold hover:border-blue-500 transition-colors duration-200"
              >
                <span>Explore Services</span>
                <Icon name="RocketLaunchIcon" size={20} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}